module.exports = __webpack_public_path__ + "img/icon-print.2ba91307.svg";